import { useState, useEffect } from 'react';

const DESKTOP_BREAKPOINT = 900;
const TABLET_BREAKPOINT = 600;

interface WindowSize {
  width: number;
  height: number;
  isDesktop: boolean;
  isTablet: boolean;
  isMobile: boolean;
}

export function useWindowSize(): WindowSize {
  const [windowSize, setWindowSize] = useState<WindowSize>(() => {
    if (typeof window !== 'undefined') {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const isDesktop = width >= DESKTOP_BREAKPOINT;
      const isTablet = width >= TABLET_BREAKPOINT && width < DESKTOP_BREAKPOINT;
      const isMobile = width < TABLET_BREAKPOINT;
      return {
        width,
        height,
        isDesktop,
        isTablet,
        isMobile,
      };
    }

    // Default values for SSR
    return {
      width: 0,
      height: 0,
      isDesktop: false,
      isTablet: false,
      isMobile: true,
    };
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const isDesktop = width >= DESKTOP_BREAKPOINT;
      const isTablet = width >= TABLET_BREAKPOINT && width < DESKTOP_BREAKPOINT;
      const isMobile = width < TABLET_BREAKPOINT;
      setWindowSize({
        width,
        height,
        isDesktop,
        isTablet,
        isMobile,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}
